import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import { Typography } from 'rmwc/Typography';
import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';
import { List, ListItem, ListItemText, ListItemGraphic} from 'rmwc/List';

class AdminLearningResourcesMainPage extends Component{
	constructor(props) {
    	super(props)
    	this.state = {
    		data:{
    		}
    	}
    }

    render(){
    	let mainPageContent = (
    		<Grid>
    			<GridCell span = "12">
    				<Card style={{padding: '25px'}}>
                        <Typography use="headline5">Learning Resources</Typography>
                    </Card>
    			</GridCell>
    			<GridCell span = "12">
    			<br />
    			<Typography use="subtitle2">Click on the link below to proceed to the learning resources.</Typography>
                <List>
                    <ListItem>
                    	<ListItemGraphic>dashboard</ListItemGraphic>
                    	<ListItemText><Link to="/portal/app/mc_roadmap">Micro-Credentials Learning Resources </Link></ListItemText>
                    </ListItem>
                    <ListItem>
                        <ListItemGraphic>table_chart</ListItemGraphic>
                        <ListItemText><Link to="/portal/app/mc_roadmap/list_of_resources">Consolidated Resources View</Link></ListItemText>
                    </ListItem>
                </List>
                </GridCell>
    		</Grid>
    	)
    	return(
    		<div>
    			{mainPageContent}
    		</div>
    	)
    }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminLearningResourcesMainPage);


// WEBPACK FOOTER //
// ./src/views/admin/AdminLearningResourcesMainPage.jsx